import { I18n } from '@app/i18n/strings-keys';

export interface CommonNameConfig {
  [key: string]: {
    singular: string;
    plural: string;
  };
}

export const COMMON_NAME_CONFIG: CommonNameConfig = {
  item: {
    singular: I18n.Common.ItemSingular,
    plural: I18n.Common.ItemsPlural,
  },
};
